<template>
    <UiCoreAdvancedTitle
        v-editable="blok"
        class="sb-core-advanced-title"
        data-test="sb-core-advanced-title"
        :blok="blok"
    />
</template>

<script setup lang="ts">
import type { ICoreAdvancedTitle } from '@nuxt-monorepo/ui/types/components/CoreAdvancedTitle';

defineProps<{ blok: ICoreAdvancedTitle }>();
</script>

<style scoped lang="postcss"></style>
